import Ads from "./Ads";
import SideNav from "./SideNav";
import navBottom from "../images/nav/nav_bottom.png";

function LeftSide() {
  return (
    <div id="left_side">
      <SideNav/>
      {/*<Ads/>*/}
      <div id="nav_bottom"><img src={navBottom} alt=""/></div>
    </div>
  );
}

export default LeftSide;